import axiosInit from 'axios'
import Configure from './configure'
import store from '../store/index'
import router from '../router'
import { Message } from 'element-ui'
import md5 from 'js-md5'
axiosInit.defaults.baseURL = Configure.base_url
function setCookie (name, value) {
  document.cookie = name + '=' + escape(value) + ';path=/'
}
let languageType
let locale = localStorage.getItem(Configure.cookie_prefix + 'locale')
if (!locale || locale === 'cn') {
  languageType = null
} else if (locale === 'en') {
  languageType = 1
}
// 判断字符是否为空的方法
function isEmpty (obj) {
  if (obj === 0) { // 等于0做特殊处理，不然默认会把0认为是null
    return false
  } else {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true
    } else {
      return false
    }
  }
}

/**
 * 所有ajax的请求前的处理
 */
function objKeySort (obj, keyValue) { // 排序的函数
  var newObj = {}// 创建一个新的对象，用于存放排好序的键值对
  if (obj) {
    var newkey = Object.keys(obj).sort()
    // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    for (var i = 0; i < newkey.length; i++) { // 遍历newkey数组
      // 去除sign加密
      if (newkey[i] === 'sign') {
        continue
      }
      if (!isEmpty(obj[newkey[i]])) { // 为空则不参与加密
        // 如果是对象数组，则继续遍历里面的元素；
        if (Object.prototype.toString.call(obj[newkey[i]]) === '[object Array]') {
          let result = innerArrayObjectHander(obj[newkey[i]])
          result = JSON.stringify(result)
          newObj[newkey[i]] = result
        } else if (typeof obj[newkey[i]] === 'string') {
          let object = obj[newkey[i]]
          if (object.indexOf('[{') === 0 && object.lastIndexOf('}]') > 0) {
            let result = innerArrayObjectHander(obj[newkey[i]])
            result = JSON.stringify(result)
            newObj[newkey[i]] = result
          } else {
            newObj[newkey[i]] = obj[newkey[i]]// 向新创建的对象中按照排好的顺序依次增加键值对
          }
        } else if (typeof obj[newkey[i]] !== 'undefined') {
          newObj[newkey[i]] = obj[newkey[i]] + ''// 如果是非字符串类型,则转成字符串类型；
        }
      }
    }
  }
  newObj.key = keyValue
  return newObj// 返回排好序的新对象
}

/**
 * 处理内部数组对象
 */
function innerArrayObjectHander (obj) {
  var arrays = []// 创建一个新的对象，用于存放排好序的键值对
  var oldArray = []// 排序前键值对数组
  if (typeof obj === 'string') { // 如果是字符串进来的对象数组要转成json数组对象
    oldArray = JSON.parse(obj)
  } else {
    oldArray = obj
  }
  for (var j = 0; j < oldArray.length; j++) {
    var map = oldArray[j]
    var newObj = {}// 创建一个新的对象，用于存放排好序的键值对
    if (map) {
      var newkey = Object.keys(map).sort()
      // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
      for (var i = 0; i < newkey.length; i++) { // 遍历newkey数组
        if (!isEmpty(map[newkey[i]])) { // 为空则不参与加密
          if (typeof map[newkey[i]] === 'string') {
            newObj[newkey[i]] = map[newkey[i]]// 向新创建的对象中按照排好的顺序依次增加键值对
          } else if (typeof map[newkey[i]] !== 'undefined') {
            newObj[newkey[i]] = map[newkey[i]] + ''// 如果是非字符串类型,则转成字符串类型；
          }
        }
      }
      arrays[j] = newObj
    }
  }

  return arrays
}

/**
 * 所有ajax的请求前参数的处理
 */
function paramHander (config, tokenKey, type) {
  let map
  if (type === 'params') {
    map = config.params
  } else {
    map = config.data
  }
  let temp = objKeySort(map, tokenKey)
  let sign = JSON.stringify(temp)
  sign = sign.replace(/\\/g, '')// 去掉“\”
  return sign
}

axiosInit.interceptors.request.use((config) => {
  // 获取到token
  let token
  if (store.state.Auth.userType === 3) {
    token = store.state.Auth.token
  }
  // let companyId = store.state.Auth.companyId
  let companyItem = localStorage.getItem('companyData')
  let companyId
  if (companyItem && companyItem !== 'undefined' && companyItem !== 'null') {
    companyItem = JSON.parse(companyItem)
    companyId = companyItem.companyId
  } else {
    companyId = ''
  }
  let tokenKey = '0193bc6e6d98832cf8a7ee23eaed4293'
  config.headers.isStudent = 1
  if (token) {
    if (config.params) {
      config.params.token = token
      config.params.languageType = languageType
      if (companyId) {
        config.params.companyId = companyId
      }
      let sign = paramHander(config, tokenKey, 'params')
      config.params.sign = md5(sign)
    } else {
      if (config.method === 'get' || config.method === 'delete') {
        config.params = {}
        config.params.token = token
        config.params.languageType = languageType
        if (companyId) {
          config.params.companyId = companyId
        }
        let sign = paramHander(config, tokenKey, 'params')
        config.params.sign = md5(sign)
      } else {
        if (config.data) {
          config.data.token = token
          config.data.languageType = languageType
          if (companyId) {
            config.data.companyId = companyId
          }
          let sign = paramHander(config, tokenKey, 'data')
          config.data.sign = md5(sign)
        } else {
          config.data = {}
          config.data.token = token
          config.data.languageType = languageType
          if (companyId) {
            config.data.companyId = companyId
          }
          let sign = paramHander(config, tokenKey, 'data')
          config.data.sign = md5(sign)
        }
      }
    }
  } else {
    if (config.params) {
      if (companyId) {
        config.params.companyId = companyId
      }
      config.params.languageType = languageType
      let sign = paramHander(config, tokenKey, 'params')
      config.params.sign = md5(sign)
    } else {
      if (config.method === 'get' || config.method === 'delete') {
        config.params = {}
        if (companyId) {
          config.params.companyId = companyId
        }
        config.params.languageType = languageType
        let sign = paramHander(config, tokenKey, 'params')
        config.params.sign = md5(sign)
      } else {
        if (config.data) {
          if (companyId) {
            config.data.companyId = companyId
          }
          config.data.languageType = languageType
          let sign = paramHander(config, tokenKey, 'data')
          config.data.sign = md5(sign)
        } else {
          config.data = {}
          if (companyId) {
            config.data.companyId = companyId
          }
          config.data.languageType = languageType
          let sign = paramHander(config, tokenKey, 'data')
          config.data.sign = md5(sign)
        }
      }
    }
  }
  return config
}, function (err) {
  return Promise.reject(err)
})

/* axiosInit.interceptors.request.use((config) => {
  // 获取到token
  let token = store.state.Auth.token
  if (token) {
    if (config.params) {
      config.params.token = token
    } else {
      if (config.method === 'get' || config.method === 'delete') {
        config.params = {}
        config.params.token = token
      } else {
        if (config.data) {
          config.data.token = token
        } else {
          config.data = {}
          config.data.token = token
        }
      }
    }
  }
  return config
}, function (err) {
  return Promise.reject(err)
}) */

/**
 * 所有ajax的请求返回值的处理
 */
let isToken = false
axiosInit.interceptors.response.use((rsp) => {
  // 在这里对返回的数据进行处理
  // switch (rsp.data.resultCode) {
  //   case -1:
  //     // Message.error('登录已失效，请重新登录！')
  //     setTimeout(function () {
  //       // 清空登录信息
  //       store.dispatch('logout').then(() => {
  //         // 重定向到登录页面
  //         setCookie('logout', 1)
  //         router.push({ name: 'Login', query: {referer: window.location.href} })
  //       })
  //     }, 500)
  //     break
  //   case -5:
  //     Message.error('角色权限已变更，请重新登录！')
  //     setTimeout(function () {
  //       // 清空登录信息
  //       store.dispatch('logout').then(() => {
  //         // 重定向到登录页面
  //         router.push({name: 'Login'})
  //       })
  //     }, 500)
  //     break
  // }
  // return rsp
  if (rsp.data.resultCode === -1) {
    if (!isToken) {
      isToken = true
      store.dispatch('logout').then(() => {
        // 重定向到登录页面
        setCookie('logout', 1)
        router.push({
          name: 'Login',
          query: {
            referer: window.location.href
          }
        })
      })
      setTimeout(() => {
        isToken = false
      }, 2000)
      // return rsp
    }
  } else {
    return rsp
  }
}, (error) => {
  // switch (error.response.status) {
  //   case 401:
  //     // Message.error('登录已失效，请重新登录！')
  //     setTimeout(function () {
  //       // 清空登录信息
  //       store.dispatch('logout').then(() => {
  //         // 重定向到登录页面
  //         setCookie('logout', 1)
  //         router.push({ name: 'Login', query: {referer: window.location.href} })
  //       })
  //     }, 500)
  //     break
  //   case 403:
  //     Message.error(error.response.data.resultMessage)
  //     setTimeout(function () {
  //       // 清空登录信息
  //       store.dispatch('logout').then(() => {
  //         // 重定向到登录页面
  //         router.push({name: 'Login'})
  //       })
  //     }, 500)
  //     break
  //   case 404:
  //     Message.error('服务器错误，请联系管理员！')
  //     break
  //   case 500:
  //     Message(error.response.data.message)
  //     break
  //   case 400:
  //     if (error.response.data.resultCode === -1) {
  //       Message.error('请先登录账号!')
  //       setTimeout(function () {
  //         // 清空登录信息
  //         store.dispatch('logout').then(() => {
  //           // 重定向到登录页面
  //           router.push({ name: 'Login', query: {referer: window.location.href} })
  //         })
  //       }, 500)
  //     } else {
  //       Message(error.response.data.resultMessage)
  //     }
  //     break
  //   case 503:
  //     Message('服务器错误，请重新尝试操作！')
  //     break
  // }
  // return Promise.reject(error)
  if (error.response.status === 401 || error.response.status === 403) {
    if (!isToken) {
      isToken = true
      // Message.error('登录已失效，请重新登录！')
      store.dispatch('logout').then(() => {
        // 重定向到登录页面
        setCookie('logout', 1)
        router.push({
          name: 'Login',
          query: {
            referer: window.location.href
          }
        })
      })
      setTimeout(() => {
        isToken = false
      }, 2000)
      return Promise.reject(error)
    }
  } else if (error.response.status === 400) {
    if (!isToken) {
      isToken = true
      // Message.error('登录已失效，请重新登录！')
      store.dispatch('logout').then(() => {
        // 重定向到登录页面
        setCookie('logout', 1)
        router.push({
          name: 'Login',
          query: {
            referer: window.location.href
          }
        })
      })
      setTimeout(() => {
        isToken = false
      }, 2000)
      return Promise.reject(error)
    }
  } else if (error.response.status === 404) {
    Message(error.response.data.error)
    return Promise.reject(error)
  } else {
    Message(error.response.data.message)
    return Promise.reject(error)
  }
})

export default axiosInit



// WEBPACK FOOTER //
// ./src/global/axios.js